import { Injectable } from "@angular/core";
import { MedicalPrescriptionValidity } from "../models/domains/pbm/Benefit/medical-prescription-validity";

import { MedicalPrescriptionRepository } from "../repositories/pbm/medical-prescription.repository";

@Injectable({ providedIn: "root" })
export class MedicalPrescriptionService {
  constructor(private medicalPrescriptionRepositoy: MedicalPrescriptionRepository) {}

  getMedicalPrescriptionValidityList(): Promise<Array<MedicalPrescriptionValidity>> {
    return this.medicalPrescriptionRepositoy.getMedicalPrescriptionValidityList();
  }
}
